import React, { VFC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { RegionCityPageCard } from '../pages/Top';
import { TEXT_SECONDARY } from '../../core/styles/variables';
import {
  HomeMediaCard,
  LabelPill,
  HOME_MEDIA_DEFAULT_MEDIA_PADDING_TOP,
  clampedTextBlock,
} from '../components/home/cards';

type Props = RegionCityPageCard & {
  className?: string;
};

const CITY_NAME_CLASS = 'region-city-card-cityName';
const FURIGANA_OFFSET_PX = 12;

const Card: VFC<Props> = ({
  id,
  prefectureName,
  cityName,
  cityNameHirakana,
  description,
  coverImageUrl,
  className,
}) => {
  const classes = useStyles();
  return (
    <HomeMediaCard
      href={`/cities/${id}`}
      className={clsx(classes.cardRoot, className)}
      elevated
      mediaAspectPaddingTop={HOME_MEDIA_DEFAULT_MEDIA_PADDING_TOP}
      imageUrl={coverImageUrl}
      imageAlt={cityName}
    >
      <div className={classes.body}>
        <div className={classes.titleBlock}>
          <div className={classes.badgeWrap}>
            <LabelPill label={prefectureName} />
          </div>
          <div className={classes.nameBlock}>
            <span className={classes.furigana}>{cityNameHirakana}</span>
            <span className={clsx(classes.cityName, CITY_NAME_CLASS)}>
              {cityName}
            </span>
          </div>
        </div>
        <div className={classes.descWrap}>
          <span className={classes.description}>{description}</span>
        </div>
      </div>
    </HomeMediaCard>
  );
};

export default Card;

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    color: '#333',
    '& .MuiCardActionArea-root:hover': {
      opacity: 1,
    },
    [`&:hover .${CITY_NAME_CLASS}`]: {
      textDecoration: 'underline',
      color: theme.palette.text.primary,
      textDecorationColor: theme.palette.text.primary,
    },
  },
  body: {
    display: 'flex',
    minHeight: 0,
    flex: 1,
    flexDirection: 'column',
    backgroundColor: '#fff',
  },
  titleBlock: {
    display: 'flex',
    minWidth: 0,
    flexDirection: 'row',
    alignItems: 'stretch',
    alignSelf: 'stretch',
    justifyContent: 'flex-start',
    gap: theme.spacing(1),
  },
  badgeWrap: {
    display: 'flex',
    flexShrink: 0,
    alignItems: 'flex-start',
    paddingTop: FURIGANA_OFFSET_PX,
  },
  nameBlock: {
    position: 'relative',
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    textAlign: 'left',
    alignSelf: 'flex-end',
    paddingTop: FURIGANA_OFFSET_PX,
  },
  furigana: {
    position: 'absolute',
    left: 0,
    top: 0,
    minWidth: 0,
    textAlign: 'left',
    fontSize: theme.typography.pxToRem(10),
    color: TEXT_SECONDARY,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
    lineHeight: 1.2,
  },
  cityName: {
    fontWeight: 600,
    ...clampedTextBlock(theme, 2, { xs: 14, sm: 16 }),
  },
  descWrap: {
    display: 'flex',
    flex: 1,
    paddingTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    color: TEXT_SECONDARY,
  },
  description: {
    ...clampedTextBlock(theme, 2, { xs: 12, sm: 14 }),
  },
}));
